import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'

function OrderSummaryCard({ order, items, intl }) {
  if (!order || !items) {
    return null
  }
  const totalValue = items
    .map((item) => item.sellingPrice * item.quantity)
    .reduce((total, value) => total + value, 0)
  const formatedTotalValue = intl.formatNumber(totalValue / 100, {
    style: 'currency',
    currency: order.storePreferencesData.currencyCode,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
  })
  const itemsQuantity = items
    .map((item) => item.quantity)
    .reduce((total, value) => total + value, 0)
  return (
    <div
      className="flex flex-row justify-between items-center bg-base br2 shadow-6 c-on-base mb5 pa7"
      style={{ height: '100px', boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.05)' }}
    >
      <div className="flex flex-column">
        <FormattedMessage id="returnExchange.summary.orderNumber" />
        <span className="t-heading-3 pt2">{order.orderId}</span>
      </div>
      <div className="flex flex-column">
        <FormattedMessage id="returnExchange.summary.value" />
        <span
          className={`t-heading-3 pt2 ${totalValue === 0 ? 'c-muted-3' : ''}`}
        >
          {formatedTotalValue}
        </span>
      </div>
      <div className="flex flex-column">
        <FormattedMessage id="returnExchange.summary.itemsNumber" />
        <span
          className={`t-heading-3 pt2 ${
            itemsQuantity === 0 ? 'c-muted-3' : ''
          }`}
        >
          {itemsQuantity}
        </span>
      </div>
    </div>
  )
}

OrderSummaryCard.propTypes = {
  order: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  intl: intlShape,
}

export default injectIntl(OrderSummaryCard)
